import { useGetRooms } from "@/hooks/query-hooks/useRoom";
import { Divider, Flex, Input } from "antd";
import { useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { AnimatedComponent, PageTitle } from "../common";
import { CreateNewRoom } from "./CreateNewRoom";
import { RoomTable } from "./RoomTable";
import { WaitingRoom } from "./WaitingRoom";

export function RoomList() {
	const [page, setPage] = useState(1);
	const [keyword, setKeyword] = useState<string | undefined>(undefined);
	const { data: rooms = [], isLoading } = useGetRooms();

	const filteredRooms = useMemo(() => {
		if (keyword && keyword.trim().length > 0) {
			return rooms?.filter(
				(it) =>
					it.name.toLowerCase().includes(keyword.toLowerCase()) ||
					it?.meditationEvent?.title
						.toLowerCase()
						.includes(keyword.toLowerCase()),
			);
		}
		return rooms;
	}, [keyword, rooms]);

	return (
		<AnimatedComponent>
			<Helmet>
				<title> Room Management </title>
			</Helmet>
			<div className="flex items-center justify-between">
				<PageTitle>Room Management</PageTitle>
				<CreateNewRoom />
			</div>
			<Divider />

			<Flex justify="space-between">
				<Input.Search
					style={{
						maxWidth: 320,
					}}
					size="large"
					placeholder="အခန်း(သို့)တရားစခန်း အမည်"
					onSearch={(keyword) => setKeyword(keyword)}
					allowClear
				/>
				<WaitingRoom />
			</Flex>
			<br />
			<RoomTable
				dataSource={filteredRooms}
				loading={isLoading}
				currentPage={page}
				pagination={{
					current: page,
					onChange: (page) => setPage(page),
				}}
			/>
		</AnimatedComponent>
	);
}
